// extracted by mini-css-extract-plugin
export default {"is_del":"ArchiveManagmenet_is_del__Dl2sf","is_del_text":"ArchiveManagmenet_is_del_text__tNZIy","is_del_text_active":"ArchiveManagmenet_is_del_text_active__uPZAm"};